import { HeaderPopupCloseIcon, KokoonIcon } from 'assets/icons';
import { useAppContext } from 'context/AppContext';
import { ButtonText1, SB } from 'global-styles';
import Image from 'next/image';
import React from 'react';
import styled from 'styled-components';

const HeaderPopupArea = () => {
  const {
    state: { isHeaderPopupOpen },
    dispatch,
  } = useAppContext();
  const handleClosePopup = () => dispatch({ type: 'headerPopupClose' });

  if (!isHeaderPopupOpen) return null;

  return (
    <PopupArea>
      <div className="left-img-wrapper">
        <Image
          className="left-img"
          src="/asset/header/header-popup-img.png"
          alt=""
          layout="fill"
        />
      </div>
      <div className="right-img-wrapper">
        <Image
          className="right-img"
          src="/asset/header/header-popup-img.png"
          alt=""
          layout="fill"
        />
      </div>

      {/* desktop */}
      <div className="banner-desk">
        <KokoonIcon />
        <ButtonText1 className="banner-text">
          <span>Try </span>
          <strong>Bluedot AI video </strong>
          <span>Enhancer & Upscaling</span>
        </ButtonText1>
        <LearnMoreLink
          className="lm-anch"
          href="https://www.kokoon.cloud"
          target="_blank"
          rel="noreferrer"
        >
          <ButtonText1>Try now</ButtonText1>
        </LearnMoreLink>
      </div>

      {/* mobile */}
      <div className="banner-mob">
        <ButtonText1>
          <span style={{ marginRight: '0.8rem' }}>→</span>
          <a
            style={{ textDecoration: 'underline', color: '#2564ce' }}
            target="_blank"
            href="https://www.kokoon.cloud"
            rel="noreferrer"
          >
            TRY BLUEDOT AI VIDEO
          </a>
        </ButtonText1>
      </div>

      <button className="close-btn" onClick={handleClosePopup}>
        <HeaderPopupCloseIcon />
      </button>
    </PopupArea>
  );
};

export default HeaderPopupArea;

const LearnMoreLink = styled.a`
  background-color: #2564ce;
  padding: 12px 24px;
  border-radius: 9999px;
  color: #fff;
`;

const PopupArea = styled.div`
  position: absolute;
  height: 72px;
  width: 100%;
  left: 0;
  right: 0;
  top: 100%;
  background: #fff;
  .close-btn {
    position: absolute;
    border: 1px solid #4b4b4b;
    border-radius: 50%;
    padding: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 80px;
    top: 50%;
    transform: translateY(-50%);
  }
  .close-btn svg {
    flex-shrink: 0;
  }
  .left-img-wrapper,
  .right-img-wrapper {
    position: absolute;
    width: 150px;
    top: 0;
    bottom: 0;
  }
  .left-img-wrapper {
    left: 0;
  }
  .right-img-wrapper {
    right: 0;
  }

  & .right-img {
    transform: rotate(180deg);
  }

  .banner-mob {
    display: none;
    white-space: nowrap;
  }
  .banner-desk {
    white-space: nowrap;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .banner-text {
    text-transform: uppercase;
    margin: 0 72px;
  }
  .banner-text strong {
    color: ${SB};
  }

  @media screen and (max-width: 769px) {
    height: 42px;
    .close-btn {
      right: 45px;
    }
    .left-img-wrapper,
    .right-img-wrapper {
      width: 50px;
    }
    .banner-mob {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      color: ${SB};
    }
    .banner-desk {
      display: none;
    }
  }
`;
